/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import axios from "axios";
import './Componentes/CSS/estilos.css';
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";  // Ensure that the import is correct
import IconoLogo from './Componentes/SVG/IconoLogo.svg'
import ModalEmergencia from './Security/modal/emergencia';
import ModalInstructivo from "./Security/modal/instructivo";
import API_ASISTENCIA from "./Componentes/config/apisAsistencia_Variables";

function App() {
  const [dni, setDni] = useState("");
  const [rol, setRol] = useState("");
  const [clave, setClave] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [ip, setIp] = useState(null);
  const [fechaRol, setFechaRol] = useState(null);
  const [showModal, setShowModal] = useState(false);  // Estado para mostrar el modal
  const [showModal2, setShowModal2] = useState(false);  // Estado para mostrar el modal
  const [currentImageIndex, setCurrentImageIndex] = useState(0);   // Estado para controlar la imagen actual del carrusel

  const images = [
    require("./Componentes/Imagenes/logo_victoria.png"),
    require("./Componentes/Imagenes/miraflores.png"),
    require("./Componentes/Imagenes/ojo.png")

  ];

  useEffect(() => {
    const fetchIp = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setIp(data.ip);
        console.log(data.ip)
        Cookies.set("miip", data.ip);

      } catch (error) {
        console.error('Error fetching IP:', error);
      }
    };

    fetchIp();
  }, []);
  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('es-ES');
    setFechaRol(formattedDate);
    console.log(formattedDate)
  }, []);

  // Efecto para el carrusel automático
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);


  
  const encryptPassword = (password) => {
    // Use a secret key for encryption
    const secretKey = "your-secret-key";
    const encryptedPassword = CryptoJS.AES.encrypt(password, secretKey).toString();
    return encryptedPassword;
  };


  const obtenerDatos = async () => {
    let respuesta; // Declarar la variable fuera del bloque try
    try {
      const endpoint = API_ASISTENCIA.autenticacion(dni, clave);
      respuesta = await axios.get(endpoint); // Asignar el valor dentro del try
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      setErrorMessage("¡Los datos ingresados son incorrectos!");
      return; // Salir de la función si hay un error
    }

    // Usar `respuesta` aquí, ya que ahora está definida
    const rol = respuesta.data.SERE_chRol;
    const nombre = respuesta.data.SERE_chNOM;
    const apellidopat = respuesta.data.SERE_chAPEPAT;
    const apellidomat = respuesta.data.SERE_chAPEMAT;
    const dnilogin = respuesta.data.SERE_P_chDNI;
    const CONTRASENIA = respuesta.data.SERE_chCLAVE;
    const encryptedClave = encryptPassword(CONTRASENIA);

    const datos = {
      nombre: nombre,
      apellidopat: apellidopat,
      apellidomat: apellidomat,
      dnilogin: dnilogin,
      clave: encryptedClave
    };

    const datosString = JSON.stringify(datos);
    localStorage.setItem("datos", datosString);

    setRol(rol);
    Cookies.set("rol", rol);
    Cookies.set("nombre", nombre);
    Cookies.set("apellidopat", apellidopat);
    Cookies.set("apellidomat", apellidomat);
    Cookies.set("dnilogin", dnilogin);
    window.location.replace('/controlregistro');
  };


  const handleShow = () => setShowModal(true);   // Mostrar el modal
  const handleClose = () => setShowModal(false);  // Cerrar el modal

  const handleShow2 = () => setShowModal2(true);   // Mostrar el modal
  const handleClose2 = () => setShowModal2(false);  // Cerrar el modal

  const handleSubmit = (event) => {
    event.preventDefault();
    obtenerDatos();
  };

  return (
    <div className="global">
      <header></header>

      {errorMessage && <div className="error-message2">{errorMessage}</div>}

      <div className="card">
      <img
          src={images[currentImageIndex]}
          className="loginlogo"
          style={{ 
            margin: 'auto', 
            width: '100%', 
            height: '270px', 
            padding: '15px 50px',
            objectFit: 'contain'
          }}
          alt="Logo rotatorio"
        />
        <h2
          style={{
            width: '100%',
            fontSize: '13px',
            textAlign: 'center',
            padding: '10px',
            backgroundColor: '#1c70f2',
            color: 'white',
            fontWeight: 'bold'
          }}
        >
          <img src={IconoLogo} alt="Icono Logo" />
          REGISTRO DE CONTROL
        </h2>

        <form onSubmit={handleSubmit} className="form card">
          <div className="field">
            <label className="label">DNI:</label>
            <input
              className="input"
              type="text"
              value={dni}
              onChange={(e) => setDni(e.target.value)}
              autoComplete="username"
            />
          </div>

          <div className="field">
            <label className="label">CONTRASEÑA:</label>
            <input
              className="input"
              type="password"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <div className="row">

            <div className="col-12">
              <button
                type="submit"
                className="btn btn-primary btn-sm btn-block"
                style={{ fontSize: '12px', width: '100%' }}
              >
                <i className="fas fa-sign-in-alt mb-1"></i><br></br>
                <strong>INICIAR SESIÓN</strong>
              </button>
            </div>
            <div className="field">
            {/* Opción A: usar <a> para la redirección */}
            <a
              href="https://miraflores.cloudc5.com/"
              rel="noopener noreferrer"
              className="btn btn-sm btn-success w-100 mt-2"
            >
               <strong>REGRESAR MENÚ</strong>
            </a>
          </div>
          </div>

        </form>
      </div>

      {/* Incluir el ModalEmergencia y pasarle las props */}
      <ModalEmergencia
        showModal={showModal}
        handleClose={handleClose}
      />

      <ModalInstructivo
        show={showModal2} // Asegúrate de pasar la prop `show` y no `showModal2`
        handleClose2={handleClose2}
      />

    </div>
  );
}

export default App;